<template>
  <div class="vx-row">
    <div class="vx-col w-3/4">
      <div>
        <div slot="header">
          <div class="flex">
            <div class="flex justify-center item-center p-5">
              <img src="/logo.png" alt="login" class="mx-auto" width="100px" />
            </div>
            <div class="flex-1 p-5 pl-0 flex flex-col">
              <h1 class="text-4xl font-bold">Mal Pelayanan Publik</h1>
              <div class="text-4xl">Kabupaten Lombok Tengah</div>
            </div>
          </div>
        </div>
        <div class="flex flex-row p-5 flex-wrap">
          <div class="w-1/3 p-5" v-for="(counter,index) in counters" :key="index">
            <vs-card class>
              <div slot="header">
                <div class="w-full py-5">
                  <div class="w-full flex flex-col items-center">
                    <div class="flex flex-col">
                      <div class="text-3xl font-bold">{{counter.counter_name }}</div>
                    </div>
                    <div class="flex justify-center p-5">
                      <!-- <global-avatar
                        :text="getCounter(counter.counter_id) ? getCounter(counter.counter_id).name : ''"
                        :size="'70px'"
                        :fontSize="'40px'"
                      ></global-avatar> -->
                      <vs-avatar size="70px" class="mb-3" :src="counter.agency_logo"/>
                    </div>
                    <div class="flex flex-col">
                      <!-- <div
                        class="text-3xl"
                      >{{getCounter(counter.counter_id) ? getCounter(counter.counter_id).name : 'Tidak Tersedia'}}</div> -->
                      <div
                        class="text-2xl"
                      >{{counter.service_name || 'Petugas Offline'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex flex-col">
                  <div
                    v-if="counter.on_service"
                    class="text-center text-4xl font-bold text-primary"
                  >{{counter.on_service.ticket_code}}</div>
                  <div v-else class="text-center text-4xl text-grey">-</div>
                </div>
              </div>
            </vs-card>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col md:w-1/4 overflow-hidden queue-wrapper">
      <transition name="slide">
        <list-queue
          v-for="(queueList,index) in queueListPerService"
          :queueList="queueList"
          :key="index"
          v-if="section == index"
        />
      </transition>
    </div>
  </div>
</template>
<style lang="css">
.vs-card--content {
  margin-bottom: 0px;
}
.queue-wrapper {
  position: relative;
}

.queue-list {
  position: absolute;
  width: 100%;
}

.slide-leave-active {
  transition: 1s;
  transition-timing-function: ease;
}
.slide-enter-active {
  transition: 1s;
  transition-timing-function: ease;
}
.slide-enter {
  transform: translate(150%, 0);
  opacity: 0;
}
.slide-enter-to {
  /* transform: translate(100%, 0); */
  opacity: 1;
}
.slide-leave {
  opacity: 1;
}

.slide-leave-to {
  transform: translate(-100%, 0);
  opacity: 0;
}
</style>
<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import ListQueue from "./SectionListQueue";

export default {
  props: {
    bus: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      section: 0,
      services: [
        {
          name: "DPMPTSP Lombok Tengah",
          queueList: [
            {
              queue: "A-001"
            },
            {
              queue: "A-002"
            },
            {
              queue: "A-003"
            },
            {
              queue: "A-004"
            },
            {
              queue: "A-005"
            }
          ]
        },
        {
          name: "BPJS Kesehatan",
          queueList: [
            {
              queue: "B-001"
            },
            {
              queue: "B-002"
            },
            {
              queue: "B-003"
            },
            {
              queue: "B-004"
            },
            {
              queue: "B-005"
            }
          ]
        }
      ],
      axios: null,
      counters: [],
      users: [],
      queueListPerService : []
    };
  },
  mounted() {
    this.changeList();

    this.bus.$on("reload", () => {
      this.fetch();
    });
    this.axios = Axios.create({
      baseURL: process.env.VUE_APP_API_ENDPOINT,
      headers: {
        Authorization: `Bearer ${this.displayDevice.token}`
      }
    });
    this.fetch();
  },
  methods: {
    changeList() {
      var _this = this;
      setInterval(() => {
        if (_this.section == _this.counters.length - 1) {
          _this.section = 0;
        } else {
          _this.section++;
        }
      }, 6000);
    },
    fetch() {
      this.axios.get(`/device/display/queue`).then(r => {
        this.counters = r.data.data.queue.counter_list;
        this.users = r.data.data.counters;
        this.queueListPerService = r.data.data.queue.on_list;
      });
    },
    getCounter(counter_id) {
      let counter;
      this.users.map(x => {
        if (x.counter_id == counter_id) {
          counter = x;
        }
      });
      return counter;
    }
  },
  watch: {},
  computed: {
    ...mapGetters(["displayDevice"])
  },
  components: {
    ListQueue
  }
};
</script>
